import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AngularFireFunctions } from '@angular/fire/functions';
import { NotifierService } from 'angular-notifier';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/auth/auth.service';
import { environment } from '@app/environments/environment';

declare var Stripe: any;

const stripe = Stripe(environment.stripe.key);

@Component({
  selector: 'app-stripe-account',
  templateUrl: './stripe-account.component.html',
  styleUrls: ['./stripe-account.component.css']
})
export class StripeAccountComponent implements OnInit {
  processLoading = false;

  @Output() public result: EventEmitter<any> = new EventEmitter();
  @Input() showSubmit = false;
  @Output() form: EventEmitter<FormGroup> = new EventEmitter();

  private stripeAccountId: string;
  private readonly notifier: NotifierService;
  public isHovered: boolean = true;
  public days: any;
  loaded: boolean = false;
  idNumberFlag: boolean;
  maxDate: Date = new Date();
  fileFront: any;
  ipAddress: any = null;

  dateOfBirth: any;
  
  accountDetails = new FormGroup({
    email: new FormControl('', Validators.compose([Validators.required, Validators.email])),
    gender: new FormControl('', Validators.compose([Validators.required])),
    bDay: new FormControl('', Validators.compose([Validators.required])),
    address: new FormControl('', Validators.compose([Validators.required])),
    lname: new FormControl('', Validators.compose([Validators.required])),
    frontId: new FormControl(''), // Validators.compose([Validators.required])),
    fname: new FormControl('', Validators.compose([Validators.required])),
    postal_code: new FormControl('', Validators.compose([Validators.required])),
    p_id: new FormControl('', Validators.compose([Validators.required])), // 123131185
    phoneNum: new FormControl('', Validators.compose([Validators.required])),
  });
  constructor(
    private authService: AuthService,
    private router: Router,
    private fun: AngularFireFunctions,
    private notifierService: NotifierService,
    private http: HttpClient
  ) {
    this.notifier = notifierService;
    this.days = Array.from(Array(31)).map((x, i) => i);
  }

  ngOnInit() {
    this.accountDetails.valueChanges
      .subscribe(() => {
        console.log(this.accountDetails);
      });
    // set max date of bday datepicker to 10 years before
    this.maxDate.setFullYear(this.maxDate.getFullYear() - 10);
    this.authService.user.subscribe(user => {
      if (user) {
        // control for existence of stripe account based on db data
        this.stripeAccountId = user.stripe_account_ID;

        try {
          // retrieve stipe account info
          this.fun.httpsCallable('getStripeAccount')({
            accountId: user.stripe_account_ID
          }).toPromise().then((onfulfilled) => {

            const dueReq: any = onfulfilled.requirements.currently_due;
            if (Array.isArray(dueReq) && dueReq.includes('tos_acceptance.ip')) {
              this.http.get<{ ip: string }>('https://jsonip.com')
                .subscribe(data => {
                  this.ipAddress = data;
                });
            }

            const personalInfo: any = onfulfilled.individual;
            // auto fill from from data retrieved from stripe account
            if (!!personalInfo) {

              // first name and last name fields
              if (!!personalInfo.first_name && !!personalInfo.last_name) {
                this.accountDetails.controls.fname.setValue(personalInfo.first_name);
                this.accountDetails.controls.lname.setValue(personalInfo.last_name);
              } else {
                this.accountDetails.controls.fname.setValue(user.firstname);
                this.accountDetails.controls.lname.setValue(user.last_name);
              }

              // birthday
              if (!!personalInfo.dob) {
                this.accountDetails.controls.bDay.setValue(
                  new Date(personalInfo.dob.year, personalInfo.dob.month - 1, personalInfo.dob.day));
              }

              // gender
              if (!!personalInfo.gender) {
                this.accountDetails.controls.gender.setValue(personalInfo.gender);
              }

              // email
              if (!!personalInfo.email) {
                this.accountDetails.controls.email.setValue(personalInfo.email);
              } else {
                this.accountDetails.controls.email.setValue(user.email);
              }

              // address and postal code
              if (!!personalInfo.address) {
                this.accountDetails.controls.address.setValue(personalInfo.address.line1);
                this.accountDetails.controls.postal_code.setValue(personalInfo.address.postal_code);
              }

              // phone number
              if (!!personalInfo.phone) {
                this.accountDetails.controls.phoneNum.setValue(personalInfo.phone);
              }

              // todo identification number in form. if provided no need to input again
              this.idNumberFlag = personalInfo.id_number_provided;
              if (personalInfo.id_number_provided) {
                this.accountDetails.controls.p_id.setValue('already provided');
              }
            } else {
              this.accountDetails.controls.fname.setValue(user.firstname);
              this.accountDetails.controls.lname.setValue(user.last_name);

              this.accountDetails.controls.email.setValue(user.email);
              this.accountDetails.updateValueAndValidity();

              // this.accountDetails.controls.address.setValue(user.address.line1);
              // this.accountDetails.controls.postal_code.setValue(user.address.postal_code);

              // phone number
              // if (!!personalInfo.phone) {
              //   this.accountDetails.controls.phoneNum.setValue(personalInfo.phone);
              // }

              // todo identification number in form. if provided no need to input again
            }
            this.loaded = true;
          }, (onrejected) => {
            console.log('error no data');
          });
        } catch (error) {
          this.notifier.notify(
            'error',
            'Unable to fetch Stripe Account information' + error
          );
        }

      }
    });
  }

  uploadIdFront(data) {
    if (data.files && data.files[0]) {
      if (!data.files[0].type.includes('image')) {
        this.notifier.notify('error', 'Invalid file please upload .jpg, .png');
        return;
      }

      const reader = new FileReader();

      reader.onload = ((event: any) => {
        this.fileFront = reader.result;
        this.accountDetails.controls.frontId.setValue('');
        // this.fun.httpsCallable('addFrontId')({
        //   stripe_account_ID : this.stripe_account_ID,
        //   file: String.fromCharCode.apply(null, new Uint16Array(reader.result))
        // }).toPromise().then((onfulfilled) => {
        //   console.log(onfulfilled);
        // }, (onrejected) => {
        //   console.log(onrejected);
        // });
      });

      reader.readAsDataURL(data.files[0]);
    }
  }

  async updateAccount(formData) {
    this.result.emit('processloading');
    console.log('Starting Updating Stripe');

    const pii = this.idNumberFlag ? true : await stripe.createToken('pii', {
      personal_id_number: formData.value.p_id,
    });

    if (pii.error) {
      // Inform the customer that there was an error.
      this.accountDetails.controls.p_id.setErrors({ invalid: true });
      this.notifier.notify(
        'error',
        'Customer Creation Error: ' + pii.error
      );
    } else {
      try {
        const data = {
          stripe_account_ID: this.stripeAccountId,
          email: formData.value.email,
          fname: formData.value.fname,
          lname: formData.value.lname,
          gender: formData.value.gender,
          postalCode: formData.value.postal_code,
          address: formData.value.address,
          phone: formData.value.phoneNum,
          personal_id: this.idNumberFlag ? true : pii.token.id,
          dob: {
            day: formData.value.bDay.getDate(),
            month: formData.value.bDay.getMonth() + 1,
            year: formData.value.bDay.getFullYear()
          }
        };

        const resultCode = await this.fun.httpsCallable('updateAccount')(data).toPromise();
        this.notifier.notify(
          'success',
          resultCode
        );
        this.result.emit(resultCode);
        // this.router.navigate(['profile']);
      } catch (error) {
        this.notifier.notify(
          'error',
          'Failed to Update Customer Information' + error
        );
      }
    }
  }
}
